import { http, httpV2 } from "@/api";

/**
 * Solicita informações dos sinais de áudio.
 * @param {Array} monitoringElementId Id do elemento de monitoração do tipo unidade geradora.
 * @returns Array com as informações de áudio disponíveis para o ativo.
 */
const GetInformation = function(monitoringElementId)
{
	return http.get(`/Audio/${monitoringElementId}`);
};

/**
 * Solicita informações da stft.
 * @param {Number} signalRegisterId Id do registro do sinal.
 * @param {Number} SignalSettingId  Id de configuração do sinal.
 * @param {Number} WindowSize
 * @param {Number} Overlap
 * @returns Objeto com as informações da stft.
 */
const GetSTFT = function(signalRegisterId, SignalSettingId, WindowSize = 0, Overlap = 0)
{
	return httpV2.get(
		`/Audio/${signalRegisterId}/stft?SignalSettingId=${SignalSettingId}&WindowSize=${WindowSize}&Overlap=${Overlap}`
	);
};

/**
 * Solicita informações do gráfico de FFT.
 * @param {Number} signalRegisterId Id do registro do sinal.
 * @param {Number} signalSettingId Id do da configuração do sinal.
 * @returns objeto com valores para o gráfico de FFT.
 */
const GetFFTSignals = function(signalRegisterId, signalSettingId)
{
	return httpV2.get(`Audio/${signalRegisterId}/FFT?signalSettingId=${signalSettingId}`);
};

/**
 * Solicita informações do gráfico de Tendencia.
 * @param {Number} trendSignalSettingId  Id da configuração da tendencia.
 * @param {Number} signalSettingId Id do da configuração do sinal.
 * @param {String} startDateTime Filtro de data e tempo inicial.
 * @param {String} endDateTime Filtro de data e tempo final.
 * @returns objeto com valores para o gráfico de Tendencia.
 */
const GetTrendSignals = function(trendSignalSettingId, signalSettingId, startDateTime, endDateTime)
{
	const path =
	`/Audio/TrendSignals/${trendSignalSettingId}?
	signalSettingId=${signalSettingId}&startDateTime=${startDateTime}&endDateTime=${endDateTime}`;
	return httpV2.get(path);
};

/**
 * Solicita informações dos sensores de áudio.
 * @param {Number} monitoringElementId Id do elemento de monitoração do tipo unidade geradora.
 * @param {Number} sensorType tipo do sensor desejado.
 * @returns Array com as informações dos sensores áudio disponíveis.
 */
const GetAudioSensors = function(monitoringElementId, sensorType)
{
	return httpV2.get(`Audio/${monitoringElementId}/Sensors?sensorType=${sensorType}`);
};

/**
 * Solicita o áudio de um sinal e registro.
 * @param {Number} signalRegisterId Id do registro de sinal.
 * @param {Number} signalSettingId Id da configuração do sinal.
 * @returns Array com as informações de áudio disponíveis para o ativo.
 */
const Listen = function(signalRegisterId, signalSettingId)
{
	const configuration = { responseType: "arraybuffer" };
	const apiEndpoint = `/Audio/${signalRegisterId}/Listen`;
	const queryParams = `?signalSettingId=${signalSettingId}`;
	const endpoint = apiEndpoint + queryParams;
	return httpV2.get(endpoint, configuration);
};

/**
 * Solicita o arquivo de áudio de um sinal e registro.
 * @param {Number} signalRegisterId Id do registro de sinal.
 * @param {Number} signalSettingId Id da configuração do sinal.
 * @returns Array com as informações de áudio disponíveis para o ativo.
 */
const Download = function(signalRegisterId, signalSettingId)
{
	const configuration = { responseType: "blob" };
	const apiEndpoint = `/Audio/${signalRegisterId}/Download`;
	const queryParams = `?signalSettingId=${signalSettingId}`;
	const endpoint = apiEndpoint + queryParams;
	return httpV2.get(endpoint, configuration);
};

export default
{
	GetInformation, Download, Listen, GetFFTSignals, GetAudioSensors, GetTrendSignals, GetSTFT
};